import { useContext, useMemo } from 'react'
import { SettingsChordsType, SettingsPlayer } from 'player'
import { Context } from 'scala'
import { Task, TaskOperations } from '../../../../types'
import { useSettingsActions } from './use-settings-actions'
import { chordsLevel } from '../common/utils'

export interface UseSettingsProps {
  task: Task
  mainOperations: TaskOperations[]
  enableExport?: boolean
  type?: 'mastered' | 'denoised'
}

export const useSettings = ({
  task,
  type,
  enableExport,
  mainOperations
}: UseSettingsProps): SettingsPlayer => {
  const { isOwner } = task
  const { user } = useContext(Context)
  const actions = useSettingsActions({ task, mainOperations })
  const limited = useMemo(
    () => !user?.subscription?.isPremium && !task.isDemo,
    [user?.subscription?.isPremium, task.isDemo]
  )
  const showBassOnChords = useMemo(
    () => !!user?.featureFlags?.webPlayerAdvancedChords,
    [user?.featureFlags]
  )

  return useMemo(
    () => ({
      singletrack: type,
      type: true,
      backButton: true,
      volumeMaster: true,
      // loop: true,
      actions,
      changeOperations: true,
      shortcuts: true,
      // lyrics: {
      //   view: true,
      //   edit: isOwner,
      //   limited
      // },
      // sections: {
      //   view: true,
      //   edit: isOwner,
      //   limited
      // },
      pitch: {
        view: true,
        edit: false,
        max: 12,
        limited: limited ? 1 : undefined
      },
      playbackRate: {
        view: true,
        edit: false,
        limited: limited ? 10 : undefined
      },
      countIn: {
        view: true,
        max: 16,
        limited: limited ? 4 : undefined
      },
      chords: {
        view: true,
        edit: true,
        limited,
        bass: showBassOnChords,
        type: chordsLevel[
          user?.preferences?.chordSkillLevel
        ] as SettingsChordsType
      },
      export: {
        view: isOwner || !!enableExport
      }
    }),
    [
      type,
      actions,
      isOwner,
      limited,
      enableExport,
      showBassOnChords,
      user?.preferences?.chordSkillLevel
    ]
  )
}
